import isEmpty from 'lodash/isEmpty';
import {filterClassesArray} from '../utils/sheduleUtils';
import {sortStrings} from '../utils/sortStrings';

const mapTeacherSchedule = (days) => {
    const parsedEvenArray = [];
    const parsedOddArray = [];
    const parsedOddDays = [];
    const parsedEvenDays = [];
    const parsedOddClasses = [];
    const parsedEvenClasses = [];

    days.forEach(({ day, even, odd }) => {
        odd.classes.forEach((classItem) => {
            if (parsedOddClasses.findIndex((oddClass) => oddClass.id === classItem.class.id) < 0) {
                parsedOddClasses.push(classItem.class);
            }
            if (parsedOddDays.indexOf(day) < 0) {
                parsedOddDays.push(day);
            }
            if (!(classItem.class.id in parsedOddArray)) {
                parsedOddArray[classItem.class.id] = [];
            }

            parsedOddArray[classItem.class.id].push({
                day,
                cards: classItem.lessons,
            });
        });

        even.classes.forEach((classItem) => {
            if (
                parsedEvenClasses.findIndex((evenClass) => evenClass.id === classItem.class.id) < 0
            ) {
                parsedEvenClasses.push(classItem.class);
            }
            if (parsedEvenDays.indexOf(day) < 0) {
                parsedEvenDays.push(day);
            }
            if (!(classItem.class.id in parsedEvenArray)) {
                parsedEvenArray[classItem.class.id] = [];
            }

            parsedEvenArray[classItem.class.id].push({
                day,
                cards: classItem.lessons,
            });
        });
    });

    const parsedOdd = {
        days: parsedOddDays,
        classes: filterClassesArray(parsedOddClasses).sort((a, b) =>
            sortStrings(a.startTime, b.startTime),
        ),
        cards: parsedOddArray,
    };
    const parsedEven = {
        days: parsedEvenDays,
        classes: filterClassesArray(parsedEvenClasses).sort((a, b) =>
            sortStrings(a.startTime, b.startTime),
        ),
        cards: parsedEvenArray,
    };
    return { parsedOdd, parsedEven };
};

export const makeTeacherSchedule = (teacherScheduleData) => {
    const schedules = Array.isArray(teacherScheduleData)
        ? teacherScheduleData
        : [teacherScheduleData];

    return schedules.map((schedule) => {
        // A semester kept by date answers with dates and what is on them, and has no pair of
        // weeks to split into. It travels through untouched for the view to render as a calendar.
        if (schedule?.dates) {
            return {
                semester: schedule.semester,
                // Named in the payload, not read off the first exam — a teacher with none yet
                // still has a name to show.
                teacher: schedule.teacher ?? {},
                byDate: schedule,
            };
        }

        const { semester, days, teacher, revision } = schedule;
        let odd = {};
        let even = {};

        if (!isEmpty(days)) {
            const { parsedEven, parsedOdd } = mapTeacherSchedule(days);
            odd = parsedOdd;
            even = parsedEven;
        }

        return { teacher, semester, odd, even, revision };
    });
};
